var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#2C2F3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.568 11C14.44 11 13.192 13.832 13 15.728C13 16.256 13.024 16.472 13.408 16.472H15.808C16.384 16.472 16.48 16.112 16.552 15.728C16.72 15.08 17.368 14.216 18.592 14.216C19.48 14.216 20.248 14.768 20.248 15.536C20.248 16.64 18.76 16.904 17.92 17.768C17.056 18.656 16.648 19.592 16.648 21.296C16.648 21.776 16.792 22.064 17.416 22.064H19.408C20.032 22.064 20.176 21.872 20.176 21.296C20.176 19.928 21.184 19.232 22.024 18.656C22.936 18.008 24.112 17.072 24.112 15.392C24.112 12.368 21.4 11 18.568 11ZM19.672 23.072H17.008C16.576 23.072 16.312 23.216 16.312 23.768V26.432C16.312 26.984 16.576 27.128 17.008 27.128H19.672C20.104 27.128 20.368 26.984 20.368 26.432V23.768C20.368 23.216 20.104 23.072 19.672 23.072Z",
    fill: "#71828C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgePlaceholder);
export default __webpack_public_path__ + "static/media/badge_placeholder.333718afe226df0fff57a8f3824b269c.svg";
export { ForwardRef as ReactComponent };